<template>
  <a-modal
    v-model="visible"
    title="批量修改期望交货日期"
    width="500px"
    :maskClosable="false"
    :closable="false"
  >
    <a-form-model ref="form" :model="formData" :rules="rules">
      <a-form-model-item label="期望交货日期" prop="demandDate">
        <a-date-picker
          v-model="formData.demandDate"
          style="width: 100%"
          :allowClear="false"
          valueFormat="YYYY-MM-DD 00:00:00"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :disabled="loading" @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="loading" @click="submit">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import { apiScpPlanPurchaseOrderBatchEditDemandDate } from '@/api/scp/purchase/purchaseApi'

export default {
  name: 'BatchEditDemandDateModal',
  data() {
    return {
      visible: false,
      loading: false,
      selectedRows: [],
      formData: {
        demandDate: undefined
      },
      rules: {
        demandDate: [{ required: true, message: '请选择期望交货日期', trigger: 'change' }]
      }
    }
  },
  methods: {
    show(rows) {
      this.selectedRows = rows
      this.formData.demandDate = undefined
      this.visible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    handleCancel() {
      this.visible = false
      this.$refs.form && this.$refs.form.resetFields()
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid || this.loading) return

        this.loading = true
        apiScpPlanPurchaseOrderBatchEditDemandDate({
          ids: this.selectedRows.map(item => item.id),
          demandDate: this.formData.demandDate
        }).then(response => {
          if (response.code === 200) {
            this.visible = false
            this.$emit('success')
          } else {
            this.$message.error(response.msg || '修改失败')
          }
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>
